export const API_BASE_URL = {
  'production': 'https://topedit-test-platform-service.topeditsci.com',
  'lan': 'https://topedit-test-platform-service.topeditsci.com',
  'development': 'https://testdb-platform-service.topeditsci.com'
}[process.env.NODE_ENV]
// 生产环境地址 https://topedit-test-platform-service.topeditsci.com
// 测试环境地址 https://testdb-platform-service.topeditsci.com

// cookie域
export const COOKIE_DOMAIN = {
  'production': 'topeditsci.com',
  'lan': 'topedit-platform-en.youpin-k8s.net',
  'development': 'localhost'
}[process.env.NODE_ENV]

// 英文官网地址
export const OFFICIAL_WEB_URL = {
  'production': `https://en.topeditsci.com`,
  'lan': `http://topedit-home-en.youpin-k8s.net`,
  'development': `http://localhost:8303`
}[process.env.NODE_ENV]

// 用户中文站点登录
export const PLATFORM_URL_ZH = {
  'production': 'https://platform.topeditsci.com/login/user',
  'lan': 'http://topedit-platform.youpin-k8s.net/login/user',
  'development': 'http://localhost:8097/login/user'
}[process.env.NODE_ENV]

// 服务商列表
export const SERVICE_PROVIDERS = {
  researcher: {
    id: '7c7ecea4a747e6c7f94eed1cac747a0c',
    discount: 0.9,
    name: 'researcher',
    antiDiscount: 1.1111
  },
  bentham: {
    id: 'b7a9593fdc03b00c3ca4a3c701edf38e',
    discount: 0.85,
    name: 'bentham',
    antiDiscount: 1.1765
  },
  hindawi: {
    id: '99a5243fdc03b00c3ca4a3c701edf38e',
    discount: 0.85,
    name: 'hindawi',
    antiDiscount: 1.1765
  },
  techscience: {
    id: '8d9fdfb5b847e6c7f94eed1cac759b1d',
    discount: 0.8,
    name: 'techscience',
    antiDiscount: 1.25
  },
  maxapress: {
    id: '5c8edfb5b847e6c7f94eed1cac485c2c',
    discount: 0.9,
    name: 'maxapress',
    antiDiscount: 1.1111
  }
}



// WEBPACK FOOTER //
// ./src/config/index.js